import { useNavigate } from "react-router-dom";

export const handleGoToPdf = (currentSequence: any, pathCoords: any, navigate: ReturnType<typeof useNavigate>) => {

  const routeData = { currentSequence, pathCoords }

  navigate("/pdf-route", { state: routeData });
};
